// extracted by mini-css-extract-plugin
export default {"wider":"styles_wider__OL6dt"};